module.exports = __webpack_public_path__ + "static/media/quarteto_coliseu_1.4f93bc32.jpg";